export const ACT_P_ORDER= "ACT_P_ORDER"
export const ACT_ORDER= "ACT_ORDER"
export const ACT_GO= "ACT_GO"
export const ACT_E_GO= "ACT_E_GO"



// WEBPACK FOOTER //
// ./src/constant/act_stat.js